import { app, firebase, functions } from '@/vendors/firebase/firebase';
import UserProfile from '@/entities/UserProfile';
import axios from 'axios';
import authTransformer from './authTransformer';
import User from '../../../entities/User';

const ls = require('local-storage');

export default {
  async loginWithCredentials(email, password) {
    const { user } = await firebase
      .auth()
      .signInWithEmailAndPassword(email, password);
    return user;
  },
  async getAllUsers() {
    const res = [];
    const snapshot = await app.firestore()
      .collection('users')
      .get();
    snapshot.forEach((doc) => {
      res.push(authTransformer.transformOne(doc.data()));
    });
    return authTransformer.transformList(res);
  },
  async logout() {
    return Promise.resolve(true);
  },
  async loginWithCustomToken(token) {
    await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION);
    const { user } = await firebase.auth().signInWithCustomToken(token);
    return { user };
  },
  // Important: cette partie permet de s'identifier avec un custom token
  // généré depuis l'app admin secteur.
  async getCurrentCustomTokenUserInfo() {
    try {
      const { claims } = await firebase.auth().currentUser.getIdTokenResult();
      return claims.userInfo;
    } catch {
      return null;
    }
  },
  async getUsersFromShop() {
    const url = process.env.VUE_APP_LIST_USERS_ENDPOINT;
    const shopToken = ls.get('shopToken');
    const { data } = await axios.get(url, { headers: { 'shop-token': shopToken } });
    return data.map((user) => new User(user));
  },
  async createShopUser(userProfile, userPassword, shopId) {
    const { data } = await functions.httpsCallable('createShopUser')({
      userProfile,
      userPassword,
      shopId,
    });
    return new UserProfile(data);
  },
};
